module.exports = __webpack_public_path__ + "img/togo.d6464ea4.png";